import MuiChip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

import { PaymentStatus } from 'constants/enums';

export const PAYMENT_STATUS_COLOR = {
  [PaymentStatus.NONE]: '#F0F0F0',
  [PaymentStatus.PENDING_PAYMENT]: '#FDEBD0',
  [PaymentStatus.PROCESSING_PAYMENT]: '#DFF0D8',
  [PaymentStatus.PENDING_CONFIRM]: '#FDEBD0',
  [PaymentStatus.PAID]: '#DFF0D8',
  [PaymentStatus.PAYMENT_FAILED]: '#ff9999',
  [PaymentStatus.UNKNOWN]: '#F0F0F0',
};

export const Chip = styled(MuiChip)<{ paymentStatus: PaymentStatus }>(({ paymentStatus, theme }) => ({
  backgroundColor: PAYMENT_STATUS_COLOR[paymentStatus],
  color: theme.palette.text.primary,
  borderRadius: '6px',
  height: '30px',
  padding: theme.spacing(0, 1),
  marginBottom: theme.spacing(2),
})) as typeof MuiChip | FC<{ paymentStatus: PaymentStatus }>;
